import { render } from "./BNavbarNav.vue?vue&type=template&id=6d4e0bf6"
import script from "./BNavbarNav.vue?vue&type=script&lang=js"
export * from "./BNavbarNav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__